import React from 'react';
import {withRouter} from "../../../../utils/services/with-router";
import {connect} from "react-redux";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import RequestCard from "./OrdersCard";
import {Flex} from "antd";
import ApprovedRequestCard from "./OrdersCard";
import OrdersCard from "./OrdersCard";

const OrdersList = () => {
    const requests = [
        {
            id: 1,
            title: "دوربین عکاسی",
            timeLeft: "روز مانده تا اتمام قرارداد 30",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            price: "1,500,000"
        }, {
            id: 2,
            title: "دوربین",
            timeLeft: "روز مانده تا اتمام قرارداد 30",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            price: "1,500,000"
        }, {
            id: 3,
            title: "دوربین",
            timeLeft: "روز مانده تا اتمام قرارداد 30",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            price: "1,500,000"
        }, {
            id: 4,
            title: "دوربین",
            timeLeft: "روز مانده تا اتمام قرارداد 30",
            fromDate: "1403/01/01",
            toDate: "1403/02/01",
            price: "1,500,000"
        },
    ];
    return (
        <Flex gap={"small"} vertical>
            {requests.map((item: any) => <OrdersCard detail={item}/>)}
        </Flex>
    );
};


export default connect(null, {})(
    withRouter(OrdersList)
);
